import Icon from 'veui/components/Icon'

Icon.register({
  comment: {
    paths: [
      {
        d: 'M64 96h641a32 32 0 0132 32v480a32 32 0 01-32 32h-97v64a32 32 0 01-46.31 28.62L376.45 640H64a32 32 0 01-32-32V128a32 32 0 0132-32zm32 480h288a32 32 0 0114.31 3.38L544 652.22V608a32 32 0 0132-32h97V160H96zm352-288a32 32 0 00-32-32H224a32 32 0 000 64h192a32 32 0 0032-32zm128 128a32 32 0 00-32-32H224a32 32 0 000 64h320a32 32 0 0032-32z'
      }
    ],
    width: '768',
    height: '768'
  }
})
